/* TSF · ficha de producto: galería, reseñas, muestra, recomendados y barra fija móvil. */
(function () {
  if (window.__tsfpInit) return;
  window.__tsfpInit = true;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const store = {
    get(key, fallback) {
      try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch (e) { return fallback; }
    },
    set(key, value) {
      try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* sin storage */ }
    },
  };

  /* ---------------- Galería: flechas + contador "1 / N" ---------------- */
  function initGallery(root) {
    const nav = $('.tsfp-gallery__nav', root);
    const viewer = $('slider-component[id^="GalleryViewer"]', root);
    const thumbsWrap = $('[id^="GalleryThumbnails"]', root);
    if (!nav || !viewer || !thumbsWrap) return;
    viewer.appendChild(nav);
    nav.hidden = false;

    const cur = $('[data-cur]', nav);
    const thumbs = () => $$('.thumbnail-list__item', thumbsWrap).filter((li) => !li.classList.contains('thumbnail-list_item--variant') || li === thumbsWrap.querySelector('.thumbnail-list__item'));
    const activeIndex = () => {
      const list = thumbs();
      const i = list.findIndex((li) => li.querySelector('button[aria-current]'));
      return i < 0 ? 0 : i;
    };
    const paint = () => { if (cur) cur.textContent = activeIndex() + 1; };
    const go = (delta) => {
      const list = thumbs();
      if (!list.length) return;
      const next = list[(activeIndex() + delta + list.length) % list.length];
      next.querySelector('button')?.click();
    };
    $('.tsfp-gallery__arrow--prev', nav).addEventListener('click', () => go(-1));
    $('.tsfp-gallery__arrow--next', nav).addEventListener('click', () => go(1));
    new MutationObserver(paint).observe(thumbsWrap, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    paint();
  }

  /* ---------------- Review highlights ---------------- */
  /* ---------------- Columna izquierda fija (escritorio) ---------------- */
  function initStickyMedia(root) {
    const media = $('.tsfp-media__stick', root);
    if (!media) return;
    const hl = $('.tsfp-hl--desk', root);
    const header = document.querySelector('sticky-header, .section-header');
    const fit = () => {
      if (window.innerWidth < 990) return;
      const top = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + 16;
      media.style.setProperty('--tsfp-sticky-top', `${Math.round(top)}px`);
      if (!hl) return;
      // Si la foto + destacadas no entran en la pantalla, se ocultan las destacadas y la foto queda entera a la vista
      hl.removeAttribute('data-nofit');
      if (media.offsetHeight + top > window.innerHeight) hl.setAttribute('data-nofit', '');
    };
    fit();
    window.addEventListener('resize', fit);
    window.addEventListener('load', fit);
    $$('img', media).forEach((img) => img.complete || img.addEventListener('load', fit, { once: true }));
  }

  function initHighlights(root) {
    $$('.tsfp-hl', root).forEach((box) => initHighlightBox(box));
  }

  function initHighlightBox(box) {
    if (!box) return;
    const slides = $$('.tsfp-hl__slide', box);
    const btn = $('.tsfp-hl__next', box);
    if (slides.length < 2) return;
    let i = 0;
    let timer;
    const show = (n) => {
      slides[i].hidden = true;
      i = (n + slides.length) % slides.length;
      slides[i].hidden = false;
    };
    const auto = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), 8000); };
    btn?.addEventListener('click', () => { show(i + 1); auto(); });
    box.addEventListener('mouseenter', () => clearInterval(timer));
    box.addEventListener('mouseleave', auto);
    auto();
  }

  /* ---------------- Reseñas ---------------- */
  function initReviews(root) {
    const wrap = $('.tsfp-reviews', root);
    if (!wrap) return;
    const productId = $('product-info', root)?.dataset.productId || '';
    const list = $('[data-tsfp-list]', wrap);
    const formWrap = $('#TsfReviewFormWrap', wrap);
    const writeBtn = $('[data-tsfp-write]', wrap);

    const openForm = (scroll = true) => {
      if (!formWrap) return;
      formWrap.hidden = false;
      writeBtn?.setAttribute('aria-expanded', 'true');
      if (scroll) formWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => $('input[type="radio"]', formWrap)?.focus({ preventScroll: true }), 400);
    };
    const closeForm = () => {
      if (!formWrap) return;
      formWrap.hidden = true;
      writeBtn?.setAttribute('aria-expanded', 'false');
    };
    writeBtn?.addEventListener('click', () => (formWrap.hidden ? openForm() : closeForm()));
    $('[data-tsfp-write-cancel]', wrap)?.addEventListener('click', () => { closeForm(); writeBtn?.focus(); });
    if ($('[data-tsfp-posted]', wrap)) openForm(true);

    // Accesos desde la columna de compra
    $$('[data-tsfp-goto-reviews]', root).forEach((a) =>
      a.addEventListener('click', (e) => {
        e.preventDefault();
        wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (a.hasAttribute('data-tsfp-open-form')) setTimeout(() => openForm(false), 500);
      })
    );

    if (!list) return;
    const items = $$('.tsfp-rv', list);
    const perPage = parseInt(wrap.dataset.perPage, 10) || 5;
    const pager = $('[data-tsfp-pages]', wrap);
    const empty = $('[data-tsfp-empty]', wrap);
    const search = $('[data-tsfp-search]', wrap);
    const ratingSel = $('[data-tsfp-filter-rating]', wrap);
    const mediaChk = $('[data-tsfp-media]', wrap);
    const sortSel = $('[data-tsfp-sort]', wrap);
    const chips = $$('.tsfp-chip', wrap);
    const bars = $$('.tsfp-bar', wrap);
    const state = { q: '', rating: '', media: false, topic: '', sort: sortSel?.value || 'rating-desc', page: 1 };

    // "tooling" -> "tool", "shipping" -> "shipp": así el tema encuentra "tools", "shipped", etc.
    const words = (t) => t.split(/[^a-z0-9]+/).filter((w) => w.length > 3).map((w) => w.replace(/(ing|s)$/, ''));
    items.forEach((el, i) => { el.dataset.order = i; });
    const sorters = {
      relevance: (a, b) => a.dataset.order - b.dataset.order,
      'rating-desc': (a, b) => b.dataset.rating - a.dataset.rating || b.dataset.date - a.dataset.date,
      'rating-asc': (a, b) => a.dataset.rating - b.dataset.rating || b.dataset.date - a.dataset.date,
      'date-desc': (a, b) => b.dataset.date - a.dataset.date,
      media: (a, b) => b.dataset.media - a.dataset.media || b.dataset.rating - a.dataset.rating,
    };

    function clampTexts(scope) {
      $$('.tsfp-rv:not([hidden]) .tsfp-rv__text', scope).forEach((p) => {
        if (p.dataset.expanded) return;
        const more = p.nextElementSibling;
        p.classList.add('is-clamped');
        const overflow = p.scrollHeight > p.clientHeight + 2;
        if (!overflow) p.classList.remove('is-clamped');
        if (more) more.hidden = !overflow;
      });
    }

    function renderPager(total) {
      if (!pager) return;
      const pages = Math.ceil(total / perPage);
      pager.innerHTML = '';
      if (pages < 2) return;
      const mk = (label, page, opts = {}) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.innerHTML = label;
        if (opts.current) b.setAttribute('aria-current', 'page');
        if (opts.disabled) b.disabled = true;
        if (opts.aria) b.setAttribute('aria-label', opts.aria);
        b.addEventListener('click', () => {
          state.page = page;
          apply(false);
          wrap.querySelector('.tsfp-sort')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        pager.appendChild(b);
      };
      const chev = (d) => `<svg class="tsfp-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;
      mk(chev('m14.5 5-7 7 7 7'), state.page - 1, { disabled: state.page === 1, aria: 'Previous page' });
      let start = Math.max(1, state.page - 2);
      const end = Math.min(pages, start + 4);
      start = Math.max(1, end - 4);
      for (let p = start; p <= end; p++) mk(String(p), p, { current: p === state.page, aria: `Page ${p}` });
      mk(chev('m9.5 5 7 7-7 7'), state.page + 1, { disabled: state.page === pages, aria: 'Next page' });
    }

    function apply(resetPage = true) {
      if (resetPage) state.page = 1;
      const q = state.q.trim().toLowerCase();
      const topicWords = state.topic ? words(state.topic) : [];
      const matches = items.filter((el) => {
        const t = el.dataset.text || '';
        if (q && !t.includes(q)) return false;
        if (state.rating && el.dataset.rating !== state.rating) return false;
        if (state.media && el.dataset.media !== '1') return false;
        if (topicWords.length && !topicWords.some((w) => t.includes(w))) return false;
        return true;
      });
      matches.sort(sorters[state.sort] || sorters['rating-desc']);
      matches.forEach((el) => list.appendChild(el));
      const from = (state.page - 1) * perPage;
      const pageItems = new Set(matches.slice(from, from + perPage));
      items.forEach((el) => { el.hidden = !pageItems.has(el); });
      if (empty) empty.hidden = matches.length > 0;
      renderPager(matches.length);
      bars.forEach((b) => b.classList.toggle('is-active', b.dataset.tsfpRating === state.rating));
      chips.forEach((c) => c.classList.toggle('is-active', c.dataset.tsfpTopic === state.topic));
      requestAnimationFrame(() => clampTexts(list));
    }

    let t;
    search?.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(() => { state.q = search.value; apply(); }, 180);
    });
    ratingSel?.addEventListener('change', () => { state.rating = ratingSel.value; apply(); });
    mediaChk?.addEventListener('change', () => { state.media = mediaChk.checked; apply(); });
    sortSel?.addEventListener('change', () => { state.sort = sortSel.value; apply(); });
    bars.forEach((b) =>
      b.addEventListener('click', () => {
        state.rating = state.rating === b.dataset.tsfpRating ? '' : b.dataset.tsfpRating;
        if (ratingSel) ratingSel.value = state.rating;
        apply();
        wrap.querySelector('.tsfp-sort')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
    );
    const setTopic = (topic) => { state.topic = state.topic === topic ? '' : topic; apply(); };
    chips.forEach((c) => c.addEventListener('click', () => setTopic(c.dataset.tsfpTopic)));
    $$('.tsfp-topics [data-tsfp-topic]', root).forEach((a) =>
      a.addEventListener('click', (e) => {
        e.preventDefault();
        state.topic = '';
        setTopic(a.dataset.tsfpTopic);
        (wrap.querySelector('.tsfp-chips') || wrap).scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
    );

    // Leer más
    list.addEventListener('click', (e) => {
      const more = e.target.closest('.tsfp-rv__more');
      if (!more) return;
      const p = more.previousElementSibling;
      p.classList.remove('is-clamped');
      p.dataset.expanded = '1';
      more.hidden = true;
    });

    // ¿Te sirvió? (se recuerda en este navegador)
    const votesKey = 'tsfp-votes';
    const votes = store.get(votesKey, {});
    const paintVotes = (rv) => {
      const key = `${productId}-${rv.dataset.idx}`;
      $$('.tsfp-rv__vote', rv).forEach((b) => {
        const on = votes[key] === b.dataset.vote;
        b.classList.toggle('is-voted', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.querySelector('span').textContent = on ? '1' : '0';
      });
    };
    items.forEach(paintVotes);
    list.addEventListener('click', (e) => {
      const b = e.target.closest('.tsfp-rv__vote');
      if (!b) return;
      const rv = b.closest('.tsfp-rv');
      const key = `${productId}-${rv.dataset.idx}`;
      votes[key] = votes[key] === b.dataset.vote ? undefined : b.dataset.vote;
      store.set(votesKey, votes);
      paintVotes(rv);
    });

    // Galería de clientes
    const track = $('.tsfp-cgal__track', wrap);
    if (track) {
      const prev = $('.tsfp-cgal__prev', wrap);
      const next = $('.tsfp-cgal__next', wrap);
      const edges = () => {
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
        const hide = track.scrollWidth <= track.clientWidth + 4;
        prev.hidden = hide;
        next.hidden = hide;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }));
      track.addEventListener('scroll', edges, { passive: true });
      window.addEventListener('resize', edges);
      edges();
    }

    // Lightbox de fotos
    const lb = $('[data-tsfp-lb]', wrap);
    if (lb) {
      const img = $('[data-tsfp-lb-img]', lb);
      const rvBox = $('[data-tsfp-lb-review]', lb);
      let lastFocus;
      const close = () => { lb.hidden = true; document.body.style.overflow = ''; lastFocus?.focus(); };
      wrap.addEventListener('click', (e) => {
        const ph = e.target.closest('.tsfp-ph');
        if (!ph) return;
        lastFocus = ph;
        img.src = ph.dataset.full;
        const src = document.getElementById(`tsfp-rv-${ph.dataset.rv}`);
        rvBox.innerHTML = '';
        if (src) {
          const clone = src.cloneNode(true);
          clone.removeAttribute('id');
          clone.hidden = false;
          rvBox.appendChild(clone);
        }
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
        $('[data-tsfp-lb-close]', lb).focus();
      });
      lb.addEventListener('click', (e) => { if (e.target === lb || e.target.closest('[data-tsfp-lb-close]')) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !lb.hidden) close(); });
    }

    apply();
  }


  /* ---------------- Quantity breaks (bundle propio) ---------------- */
  function formatMoney(cents, format) {
    const fmt = format || '${{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const num = (value, decimals, thousands = ',', decimal = '.') => {
      const [a, b] = (value / 100).toFixed(decimals).split('.');
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (b ? decimal + b : '');
    };
    const m = fmt.match(re);
    if (!m) return fmt;
    const map = {
      amount: () => num(cents, 2),
      amount_no_decimals: () => num(cents, 0),
      amount_with_comma_separator: () => num(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => num(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => num(cents, 2, "'"),
    };
    return fmt.replace(re, (map[m[1]] || map.amount)());
  }
  window.tsfpFormatMoney = formatMoney;

  function initQtyBreaks(root) {
    const qb = $('tsf-qty-breaks', root);
    if (!qb) return;
    const sectionId = qb.dataset.section;
    const fmt = qb.dataset.moneyFormat;
    let prices = {};
    try { prices = JSON.parse($('[data-tsfp-qb-prices]', qb).textContent); } catch (e) { /* sin precios */ }
    const tiers = $$('.tsfp-qb__tier', qb);
    const qtyInput = () => document.getElementById(`Quantity-${sectionId}`);
    const variantInput = () => document.querySelector(`#product-form-${sectionId} input[name="id"]`);

    // Sin stock no se ofrecen escalones: se esconden cuando la variante elegida está agotada
    const soldOut = (qb.dataset.soldout || '').split(',').filter(Boolean);
    const paintPrices = () => {
      const vid = variantInput()?.value;
      if (vid) qb.hidden = soldOut.includes(String(vid));
      const price = prices[vid];
      if (price == null) return;
      tiers.forEach((t) => {
        const qty = +t.dataset.qty;
        const pct = +t.dataset.pct;
        const each = Math.round((price * (100 - pct)) / 100);
        const set = (sel, v) => { const el = t.querySelector(sel); if (el) el.textContent = formatMoney(v, fmt); };
        set('[data-each]', each);
        set('[data-compare]', price);
        set('[data-save]', (price - each) * qty);
      });
    };
    const select = (tier) => {
      tiers.forEach((t) => {
        const on = t === tier;
        t.classList.toggle('is-selected', on);
        t.querySelector('input').checked = on;
      });
    };
    const tierFor = (qty) => {
      let best = tiers[0];
      tiers.forEach((t) => { if (qty >= +t.dataset.qty) best = t; });
      return best;
    };

    tiers.forEach((t) =>
      t.querySelector('input').addEventListener('change', () => {
        select(t);
        const input = qtyInput();
        if (input && +input.value !== +t.dataset.qty) {
          input.value = t.dataset.qty;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      })
    );
    // La cantidad manda: si la cambian con +/- o a mano, se marca el escalón que corresponde
    document.addEventListener('change', (e) => {
      if (e.target === qtyInput()) select(tierFor(+e.target.value || 1));
      if (e.target === variantInput()) paintPrices();
    });
    root.addEventListener('click', (e) => {
      if (e.target.closest('.quantity__button')) setTimeout(() => select(tierFor(+qtyInput()?.value || 1)), 0);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(paintPrices, 30));
    }
    select(tierFor(+qtyInput()?.value || 1));
    paintPrices();
  }

  /* ---------------- Agregar al carrito por AJAX (caja de muestra) ---------------- */
  function ajaxAdd(form) {
    const btn = form.querySelector('[type="submit"]');
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const fd = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
      fd.append('sections_url', window.location.pathname);
      cart.setActiveElement?.(document.activeElement);
    }
    btn?.setAttribute('aria-disabled', 'true');
    btn?.classList.add('loading');
    return fetch(`${window.routes?.cart_add_url || '/cart/add'}`, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd,
    })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) {
          window.alert(res.description || res.message || 'Could not add to cart');
          return;
        }
        if (!cart) {
          window.location = window.routes?.cart_url || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tsfp', productVariantId: fd.get('id'), cartData: res });
        }
        cart.classList.contains('is-empty') && cart.classList.remove('is-empty');
        cart.renderContents(res);
      })
      .catch(() => { window.location = window.routes?.cart_url || '/cart'; })
      .finally(() => {
        btn?.removeAttribute('aria-disabled');
        btn?.classList.remove('loading');
      });
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-tsfp-ajax-add]');
    if (!form) return;
    e.preventDefault();
    ajaxAdd(form);
  });
  window.tsfpAjaxAdd = ajaxAdd;

  /* ---------------- "You may also like" ---------------- */
  function relState(rel) {
    const track = $('.tsfp-rel__track', rel);
    if (!track) return;
    const bar = $('.tsfp-rel__bar span', rel);
    const prev = $('.tsfp-rel__prev', rel);
    const next = $('.tsfp-rel__next', rel);
    const max = track.scrollWidth - track.clientWidth;
    const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
    if (bar) {
      bar.style.width = `${Math.min(100, ratio * 100)}%`;
      const pos = max > 0 ? track.scrollLeft / max : 0;
      bar.style.transform = `translateX(${pos * ((1 - ratio) / ratio) * 100}%)`;
    }
    if (prev) prev.disabled = track.scrollLeft < 4;
    if (next) next.disabled = track.scrollLeft >= max - 4;
    const arrows = $('.tsfp-rel__arrows', rel);
    if (arrows) arrows.style.visibility = max > 4 ? '' : 'hidden';
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.tsfp-rel__next, .tsfp-rel__prev');
    if (!btn) return;
    const rel = btn.closest('.tsfp-rel');
    const track = $('.tsfp-rel__track', rel);
    const card = $('.tsfp-card', track);
    const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth;
    track.scrollBy({ left: btn.classList.contains('tsfp-rel__next') ? step : -step, behavior: 'smooth' });
  });
  document.addEventListener('scroll', (e) => {
    const track = e.target.closest?.('.tsfp-rel__track');
    if (track) relState(track.closest('.tsfp-rel'));
  }, true);
  function initRelated() {
    $$('.tsfp-rel').forEach((rel) => {
      relState(rel);
      new MutationObserver(() => relState(rel)).observe(rel, { childList: true });
    });
    window.addEventListener('resize', () => $$('.tsfp-rel').forEach(relState));
  }

  /* ---------------- Barra fija de compra (móvil) ---------------- */
  function initSticky(root) {
    const bar = $('.tsfp-satc', root);
    const main = $('.tsfp-buy .product-form__submit', root);
    if (!bar || !main) return;
    const btn = $('.tsfp-satc__btn', bar);
    const priceEl = $('[data-tsfp-satc-price]', bar);
    const sectionId = $('product-info', root)?.dataset.section;
    const footer = document.querySelector('footer, .footer, .shopify-section-group-footer-group');
    let ticking = false;
    const toggle = () => {
      ticking = false;
      const r = main.getBoundingClientRect();
      const past = r.bottom < 0;
      const atFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      const on = past && !atFooter;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(toggle); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    toggle();
    const sync = () => {
      const disabled = main.hasAttribute('disabled');
      btn.disabled = disabled;
      btn.textContent = (main.querySelector('span')?.textContent || '').trim() || btn.textContent;
      const price = document.getElementById(`price-${sectionId}`);
      if (price && priceEl) {
        // Lo que se ve en pantalla (Pumper reescribe .price__container con su propio precio)
        const visible = Array.from(price.querySelectorAll('.price-item')).find((el) => el.offsetParent !== null && !el.closest('s'));
        const txt = (visible || price.querySelector('.price__container'))?.textContent.replace(/\s+/g, ' ').trim();
        if (txt) priceEl.textContent = txt;
      }
    };
    btn.addEventListener('click', () => main.click());
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(sync, 50));
    }
    sync();
    setTimeout(sync, 1500);
  }

  function initRoot(root) {
    if (!root || root.dataset.tsfpReady || !$('product-info', root)) return;
    root.dataset.tsfpReady = '1';
    const inModal = root.classList.contains('tsfp-qa');
    if (inModal) {
      // Al cambiar de variante, Dawn trae las fotos nuevas con el id original de la sección (sin "quickadd-")
      // y las miniaturas ya no las encuentran: se renombran para que vuelvan a coincidir
      const pi = $('product-info', root);
      const fixMediaIds = () => {
        const orig = pi?.dataset.originalSection;
        const cur = pi?.dataset.section;
        if (!orig || !cur || orig === cur) return;
        $$('[data-media-id]', root).forEach((el) => {
          const id = el.dataset.mediaId;
          if (id.startsWith(`${orig}-`)) el.dataset.mediaId = `${cur}-${id.slice(orig.length + 1)}`;
        });
        $$('[id]', root).forEach((el) => {
          if (el.id.includes(orig) && !el.id.includes(cur)) el.id = el.id.replace(orig, cur);
        });
      };
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, () => { if (root.isConnected) fixMediaIds(); });
      }
      // En la vista rápida nada lleva a otra página: "See what they say" baja a los testimonios del propio modal
      $$('[data-tsfp-goto-reviews], .tsfp-topics a', root).forEach((a) =>
        a.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopImmediatePropagation();
          $('.tsfp-hl--mob', root)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, true)
      );
    }
    initGallery(root);
    if (!inModal) initStickyMedia(root);
    initHighlights(root);
    initReviews(root);
    initQtyBreaks(root);
    if (!inModal) initSticky(root);
  }

  function init() {
    $$('.tsfp').forEach(initRoot);
    initRelated();
  }
  // La vista rápida ("Choose options") inyecta la ficha más tarde: se inicializa al conectarse
  document.addEventListener('product-info:loaded', (e) => initRoot(e.target.closest('.tsfp')));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
